// src/store/userAtom.ts
import { atom } from 'jotai';
export const userAtom = atom(null);
